import { jsPDF } from "jspdf"

/**
 * Central helper for creating US Letter PDFs.
 *
 * - Units: millimeters
 * - Format: US Letter (8.5" x 11")
 * - Orientation: portrait by default
 *
 * Callsites can override any of these via the optional overrides object.
 */
export const createLetterPdf = (overrides = {}) => {
  return new jsPDF({
    unit: "mm",
    format: "letter",
    orientation: "portrait",
    ...overrides,
  })
}
